export default __webpack_public_path__ + "static/media/praticidade-voce.ece406ea.svg";